import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
// import fanyiPic from '@/assets/fanyi.png'
import Sortable from 'sortablejs';
import { gethotWordsList, updateHotwordsSort, addHotwords, gethotWordsDetail, updatehotWordsDetail, deleteHotWords } from '@/services/systemsetting/hotwords';
export default {
  name: 'hotwords',
  i18n: require('./i18n-hotwords'),
  components: {},
  data: function data() {
    return {
      updateLoading: false,
      saveLoading: false,
      nameErr: this.$t('hotwords.categorynameprop'),
      categoryLangList: [],
      /* 默认语言对 */
      defaultLangObj: {},
      /* 语言list */
      langList: [],
      datavalue: {
        id: '',
        list: []
      },
      dialogStatus: '',
      textMap: {
        //新建/修改title
        update: this.$t('hotwords.edithotwords'),
        create: this.$t('hotwords.newhotwords')
      },
      visible: false,
      //新建/修改 显示
      columns: [{
        title: this.$t('hotwords.serialnumber'),
        dataIndex: 'keywordIndex',
        key: 'keywordIndex',
        width: '10%'
      }, {
        title: this.$t('hotwords.hotwordsname'),
        dataIndex: 'keyword',
        key: 'keyword',
        scopedSlots: {
          customRender: 'keyword' //自定义表格里面的内容
        },
        ellipsis: true,
        width: '25%'
      }, {
        title: this.$t('hotwords.searchTimes'),
        dataIndex: 'searchTimes',
        key: 'searchTimes',
        scopedSlots: {
          customRender: 'searchTimes'
        },
        width: '10%',
        align: 'right'
      }, {
        title: this.$t('hotwords.creater'),
        dataIndex: 'createUsername',
        key: 'createUsername',
        width: '15%'
      }, {
        title: this.$t('hotwords.updatetime'),
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        width: '25%'
      }, {
        title: this.$t('hotwords.operation'),
        dataIndex: 'action',
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        width: '15%'
      }],
      //列表数据
      hotwordsList: [],
      isTableLoading: false,
      editId: undefined
    };
  },
  mounted: function mounted() {
    this.setSort();
    this.getInitialValue();
    this.initData();
  },
  methods: {
    /* 获取localStorage里面的默认语言 和系统设置中存的语言list */getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //因为编辑的是否需要id
          nameObj.id = '';
          nameObj.titleName = self.$t('hotwords.hotwordsname') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //热词名称
          nameObj.name = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          nameObj.showNameFY = false;
          self.categoryLangList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.datavalue.list = _.cloneDeep(self.categoryLangList);
    },
    initData: function initData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.isTableLoading = true;
              _context.n = 1;
              return gethotWordsList();
            case 1:
              res = _context.v;
              try {
                if (res.data.code == 200) {
                  _this2.hotwordsList = res.data.data;
                }
              } finally {
                _this2.isTableLoading = false;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    onClose: function onClose(e) {},
    /* 拖拽排序 */setSort: function setSort() {
      var tbody = document.querySelectorAll('.ant-table-body > table > tbody')[0];
      console.log(tbody, 'tttttttttttttttttt');
      var _this = this;
      Sortable.create(tbody, {
        onEnd: function onEnd(_ref) {
          var _this3 = this;
          return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            var newIndex, oldIndex, currRow, params, res;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  newIndex = _ref.newIndex, oldIndex = _ref.oldIndex;
                  currRow = _this.hotwordsList.splice(oldIndex, 1)[0];
                  _this.hotwordsList.splice(newIndex, 0, currRow);
                  _this.hotwordsList.forEach(function (item, index) {
                    item.keywordIndex = index + 1;
                  });
                  params = _this.hotwordsList.map(function (item) {
                    return {
                      id: item.id,
                      keywordIndex: item.keywordIndex
                    };
                  }); // 更新数据接口 只有顺序改变了才会调用接口
                  if (!(newIndex !== oldIndex)) {
                    _context2.n = 5;
                    break;
                  }
                  if (!_this3.isTableLoading) {
                    _context2.n = 1;
                    break;
                  }
                  return _context2.a(2);
                case 1:
                  _this3.isTableLoading = true;
                  _context2.p = 2;
                  _context2.n = 3;
                  return updateHotwordsSort(params);
                case 3:
                  res = _context2.v;
                  if (res.data.code == 200) {
                    _this.$message.success(_this.$t('public.updateSuccessfully'));
                  }
                case 4:
                  _context2.p = 4;
                  _this3.isTableLoading = false;
                  return _context2.f(4);
                case 5:
                  return _context2.a(2);
              }
            }, _callee2, null, [[2,, 4, 5]]);
          }))();
        }
      });
    },
    /* 添加按钮 */addModal: function addModal() {
      this.dialogStatus = 'create';
      this.visible = true;
      this.saveLoading = false;
      this.resetdatavalue();
    },
    /* 确定添加 */sureSave: function sureSave() {
      var _this4 = this;
      var self = this;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this4.saveLoading = true;
          var params = {
            keyword: {}
          };
          self.datavalue.list.forEach(function (item) {
            params.keyword[item.langId] = item.name;
          });
          addHotwords(params).then(function (response) {
            if (response.data.code == 200) {
              _this4.$message.success(_this4.$t('public.addSuccessfully'));
              _this4.initData();
              _this4.visible = false;
            }
          }).finally(function () {
            _this4.saveLoading = false;
          });
        }
      });
    },
    resetdatavalue: function resetdatavalue() {
      this.datavalue = {
        list: _.cloneDeep(this.categoryLangList)
      };
    },
    /* 编辑按钮 */updata: function updata(record) {
      var _this5 = this;
      this.editId = record.id;
      gethotWordsDetail(record.id).then(function (response) {
        if (response.data.code == 200) {
          var keywordObj = response.data.data.keyword;
          _this5.datavalue.id = response.data.data.id;
          var newNameList = _.cloneDeep(_this5.categoryLangList);
          var _iterator2 = _createForOfIteratorHelper(newNameList),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var initial = _step2.value;
              if (keywordObj.hasOwnProperty(initial.langId)) {
                initial.name = keywordObj[initial.langId];
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          _this5.datavalue.list = _.cloneDeep(newNameList);
          _this5.dialogStatus = 'update';
          _this5.visible = true;
        }
      });
    },
    /* 确定更新 */updateUser: function updateUser() {
      var self = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          self.updateLoading = true;
          var params = {
            keyword: {}
          };
          self.datavalue.list.forEach(function (item) {
            params.keyword[item.langId] = item.name;
          });
          updatehotWordsDetail(self.editId, params).then(function (response) {
            if (response.data.code == 200) {
              self.$message.success(self.$t('public.updateSuccessfully'));
              self.visible = false;
              self.initData();
            }
          }).finally(function () {
            self.updateLoading = false;
          });
        }
      });
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.visible = false;
      this.resetdatavalue();
    },
    confirm: function confirm(row) {
      var _this6 = this;
      var params = {
        id: row.id,
        keywordIndex: row.keywordIndex
      };
      deleteHotWords(row.id, params).then(function (response) {
        if (response.data.code == 200) {
          _this6.$message.success(_this6.$t('public.deleteSuccessfully'));
          _this6.initData();
        }
      });
    },
    cancel: function cancel(e) {}
  }
};